import { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { AppShell } from "./components/layout/AppShell";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { ProspectsPage } from "./pages/ProspectsPage";
import { ProspectDetailPage } from "./pages/ProspectDetailPage";
import { SalesPage } from "./pages/SalesPage";
import { PrestationsPage } from "./pages/PrestationsPage";
import { CalendarPage } from "./pages/CalendarPage";
import { TodoPage } from "./pages/TodoPage";
import { SettingsPage } from "./pages/SettingsPage";
import { WebinarsPage } from "./pages/WebinarsPage";
import { TodayPage } from "./pages/TodayPage";
import { StatsPage } from "./pages/StatsPage";
import { api } from "./lib/api";

type AuthState = "loading" | "authed" | "guest";

export function App() {
  const [auth, setAuth] = useState<AuthState>("loading");
  const location = useLocation();

  useEffect(() => {
    let active = true;
    api
      .me()
      .then((data) => {
        if (!active) return;
        setAuth(data.authed ? "authed" : "guest");
      })
      .catch(() => {
        if (active) setAuth("guest");
      });
    return () => {
      active = false;
    };
  }, [location.pathname]);

  if (auth === "loading") {
    return (
      <div className="min-h-dvh grid place-items-center">
        <div className="h-10 w-10 rounded-full border-2 border-[var(--color-navy-600)] border-r-transparent animate-spin" />
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={
          auth === "authed" ? (
            <Navigate to="/" replace />
          ) : (
            <LoginPage onAuthed={() => setAuth("authed")} />
          )
        }
      />
      {auth === "authed" ? (
        <Route element={<AppShell />}>
          <Route index element={<DashboardPage />} />
          <Route path="statistiques" element={<StatsPage />} />
          <Route path="aujourdhui" element={<TodayPage />} />
          <Route path="webinaires" element={<WebinarsPage />} />
          <Route path="prospects" element={<ProspectsPage />} />
          <Route path="prospects/:id" element={<ProspectDetailPage />} />
          <Route path="ventes" element={<SalesPage />} />
          <Route path="prestations" element={<PrestationsPage />} />
          <Route path="todo" element={<TodoPage />} />
          <Route path="calendrier" element={<CalendarPage />} />
          <Route path="parametres" element={<SettingsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      ) : (
        <Route path="*" element={<Navigate to="/login" replace />} />
      )}
    </Routes>
  );
}
